const S3_BASE =
  'https://tiktok-videos-ex-dev-11766.s3.eu-central-1.amazonaws.com'

export const videoExamplesByTaskType: Record<string, string[]> = {
  lipsync: [
    S3_BASE + '/lip-sync_kins.mp4',
    S3_BASE + '/lip-sync_GramaCarolyn.mp4',
    S3_BASE + '/lip-sync2_Yulia.mp4',
  ],
  transition: [
    S3_BASE + '/transition_Cecilia.mp4',
    S3_BASE + '/transition_Yulia.mp4',
    S3_BASE + '/transition_Rose.mp4',
  ],
  pov: [
    S3_BASE + '/POV_Sarah.mp4',
    S3_BASE + '/POV_Juan.mp4',
    S3_BASE + '/POV_Lyon%26Jena.mp4',
  ],
  first_listen_reaction: [
    S3_BASE + '/first+listen_Rose.mp4',
    S3_BASE + '/first+listen_Marie+Pie.mp4',
    S3_BASE + '/first+listen_Barci.mp4',
  ],
  get_ready_with_me: [
    S3_BASE + '/GRWM_Brittany.mp4',
    S3_BASE + '/GRWM_Sophie.mp4',
    S3_BASE + '/GRWM_Yulia.mp4',
  ],
}
